import { render, staticRenderFns } from "./m1-pos.vue?vue&type=template&id=dbde49f2&"
import script from "./m1-pos.vue?vue&type=script&lang=js&"
export * from "./m1-pos.vue?vue&type=script&lang=js&"
import style0 from "./m1-pos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports